// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__DNjie","label":"Radio_label__3xcQ4","checkMark":"Radio_checkMark__a9lFP","disabled":"Radio_disabled__2Jccr"};